import { z } from 'zod';
export const INDEX_RUN_PHASES = ['starting', 'preparing', 'selecting', 'checking', 'analyzing', 'publishing'];
const count = z.number().int().nonnegative();
export const SOURCE_PUBLICATION_STAGES = ['checking', 'inventory', 'catalog', 'saving'];
export const IndexRunProgressSchema = z.object({
    version: z.literal(1),
    phase: z.enum(INDEX_RUN_PHASES),
    done: count,
    total: count.nullable(),
    unchanged: count,
    fileName: z.string().max(512).nullable(),
    part: z.object({ done: count, total: count }).strict().nullable(),
    earlier: z.object({ finished: count, failed: count }).strict().nullable().optional(),
    publication: z.object({
        stage: z.enum(SOURCE_PUBLICATION_STAGES),
        startedAt: z.string().datetime(),
        done: count,
        total: count.nullable(),
        unit: z.enum(['files', 'objects']).nullable(),
    }).strict().nullable().optional(),
    updatedAt: z.string().datetime(),
}).strict();
export function readIndexRunProgress(value) {
    const parsed = IndexRunProgressSchema.safeParse(value);
    return parsed.success ? parsed.data : null;
}
//# sourceMappingURL=indexRunProgress.schema.js.map